import {Component} from "react";
import logo from "./images/cena en rojo_cuadrado.svg";
import "./css/Landing.css"
import App from "./App";
import {getPayments, showManual, showQR} from "./Actions";
import ManualRegister from "./ManualRegister";


export default class Landing extends Component {
    componentDidMount() {
        getPayments()
    }
    render() {
        return (
            <div className="landing">
                <img src={logo} alt="" className=""/>
                <div className="buttons-container">
                    <button onClick={showQR}>
                        Utilizar Scanner
                    </button>
                    <button onClick={showManual}>
                        Registro manual
                    </button>
                </div>
                <App/>
                <ManualRegister/>
            </div>
        )
    }
}